import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
`

export const Loading = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  &:before,
  &:after {
    position: absolute;
    border: 4px solid var(--color-primary);
    opacity: 1;
    border-radius: 50%;
    animation: ${rotate} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    display: block;
    content: '';
  }
  &:after {
    animation-delay: -0.5s;
  }
`
export const LoadingWrap = styled.div`
  position: ${({ position = 'absolute' }) => position};
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center !important;
  display: flex;
`
